import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Feature, FeatureNames, HeatingDhwProperties } from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

@Component({
  selector: 'app-warm-water-overlay',
  templateUrl: './warm-water-overlay.component.html',
  styleUrls: ['./warm-water-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarmWaterOverlayComponent implements OnInit {
  dhw$: Observable<Feature<HeatingDhwProperties, never>>;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.dhw$ = this.installationFeaturesStore.selectInstallationDeviceFeature(FeatureNames.dhw);
  }
}
